import { SVGProps } from "react";

const DefaultLogoIcon = ({
  className,
  ...props
}: SVGProps<SVGSVGElement> & { className?: string }) => (
  <svg
    viewBox="12 12 74 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <mask
      id="defaultLogo-mask0"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="12"
      width="35"
      height="35"
    >
      <path d="M12.5 12.5039H46.0822V46.0765H12.5V12.5039Z" fill="white" />
    </mask>
    <g mask="url(#defaultLogo-mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.0813 29.2843C46.0813 20.0166 38.5597 12.5039 29.2863 12.5039C20.0151 12.5039 12.4988 20.0188 12.4988 29.2843C12.4988 38.5509 20.0225 46.0765 29.298 46.0765H46.0813V29.2843Z"
        fill="#228800"
      />
    </g>
    <mask
      id="defaultLogo-mask1"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="52"
      y="12"
      width="35"
      height="35"
    >
      <path d="M52.4999 12.5039H86.0818V46.0765H52.4999V12.5039Z" fill="white" />
    </mask>
    <g mask="url(#defaultLogo-mask1)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.5 29.2804C52.5 20.0127 60.0216 12.5 69.295 12.5C78.5662 12.5 86.0825 20.0149 86.0825 29.2804C86.0825 38.547 78.5588 46.0726 69.2833 46.0726H52.5V29.2804Z"
        fill="#228800"
      />
    </g>
    <mask
      id="defaultLogo-mask2"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="52"
      y="50"
      width="35"
      height="35"
    >
      <path d="M52.5 50.9365H86.0825V84.5036H52.5V50.9365Z" fill="white" />
    </mask>
    <g mask="url(#defaultLogo-mask2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.5 67.718C52.5 76.9921 60.0195 84.5038 69.2961 84.5038C78.563 84.5038 86.0825 76.9921 86.0825 67.718C86.0825 58.4503 78.5534 50.9365 69.2801 50.9365H52.5V67.718Z"
        fill="#228800"
      />
    </g>
    <mask
      id="defaultLogo-mask3"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="12"
      y="50"
      width="35"
      height="35"
    >
      <path d="M12.5013 50.9365H46.0839V84.5036H12.5013V50.9365Z" fill="white" />
    </mask>
    <g mask="url(#defaultLogo-mask3)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.0839 67.718C46.0839 76.9921 38.5644 84.5038 29.2878 84.5038C20.0209 84.5038 12.5013 76.9921 12.5013 67.718C12.5013 58.4503 20.0304 50.9365 29.3038 50.9365H46.0839V67.718ZM29.2889 79.7683C35.9533 79.7683 41.3765 74.3634 41.3765 67.7191V55.6741H29.3048C22.6373 55.6741 17.2141 61.0779 17.2141 67.7191C17.2119 74.3624 22.6298 79.7683 29.2889 79.7683Z"
        fill="#228800"
      />
    </g>
  </svg>
);

export default DefaultLogoIcon;
